module.exports = __webpack_public_path__ + "media/assets/mobile-nav-cross-8c918cd8b68a3ed2da99fb0fa08772ea.svg";